export default __webpack_public_path__ + "static/banner-live-status-tracking-21fe6645989d6ddcc98ba35ed7e15e38.jpeg";